import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'
import chooseMediaLibraryResourcePromise from '../../components/MediaLibraryBrowser/util/chooseMediaLibraryResourcePromise'

export default class extends Controller {
  static targets = ["uploadForm", "buttonGroup", "uploadInput", "cancelWrapper", "statusMessage", "removeButton", "hiddenField"]
  static values = { uuid: String }

  connect() {
    hideTarget(this.uploadFormTarget)
    hideTarget(this.cancelWrapperTarget)
    hideTarget(this.statusMessageTarget)
    if(this.hasHiddenFieldTarget && this.hiddenFieldTarget.value) {
      showTarget(this.removeButtonTarget)
    }
    else {
      hideTarget(this.removeButtonTarget)
    }
  }

  showUploadForm(e) {
    e.preventDefault()
    showTarget(this.uploadFormTarget)
    hideTarget(this.buttonGroupTarget)
    showTarget(this.cancelWrapperTarget)
  }

  removeFile(e) {
    e.preventDefault()

    this.hiddenFieldTarget.value = ""
    const statusMessage = `File will be deleted on save`
    this.statusMessageTarget.textContent = statusMessage

    hideTarget(this.buttonGroupTarget)
    showTarget(this.statusMessageTarget)
  }

  async showMediaLibraryBrowser(e) {
    e.preventDefault()
    try {
      const mediaLibraryResource = await chooseMediaLibraryResourcePromise({ mediaLibraryUuid: this.uuidValue })

      const { uuid, file, url, filename } = mediaLibraryResource.attributes

      const statusMessage = `Selected: ${filename}`
      this.statusMessageTarget.textContent = statusMessage

      if(this.hiddenInput) {
        this.hiddenInput.remove()
      }

      this.hiddenInput = document.createElement("input")
      this.hiddenInput.type = "hidden"
      this.hiddenInput.name = this.uploadInputTarget.name
      this.hiddenInput.value = `media_library_resource:${mediaLibraryResource.attributes.uuid}`
      this.uploadInputTarget.insertAdjacentElement("beforebegin", this.hiddenInput)

      hideTarget(this.buttonGroupTarget)
      showTarget(this.statusMessageTarget)
      showTarget(this.cancelWrapperTarget)
    }
    catch(e) {
      console.info(e.message)
      return
    }
  }

  cancel(e) {
    e.preventDefault()

    if(this.hiddenInput) {
      this.hiddenInput.remove()
    }

    this.uploadInputTarget.value = ""
    this.statusMessageTarget.textContent = ""

    hideTarget(this.uploadFormTarget)
    showTarget(this.buttonGroupTarget)
    hideTarget(this.cancelWrapperTarget)
  }
}
